import { __assign } from "tslib";
import { VELT_SDK_INIT_EVENT, VELT_TAB_ID } from "../constants";
var sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
var getSessionId = function () {
    return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(VELT_TAB_ID)) || sessionId;
};
var VELT_DEFAULT_LIVE_STATE_ID = 'velt-default-redux-live-state';
export var createLiveStateMiddleware = function (config) {
    if (config === void 0) { config = {}; }
    var _a = config.allowedActionTypes, allowedActionTypes = _a === void 0 ? new Set() : _a, // Set of allowed action types for sync
    _b = config.disabledActionTypes, // Set of allowed action types for sync
    disabledActionTypes = _b === void 0 ? new Set() : _b, // Set of disabled action types for sync
    _c = config.allowAction, // Set of disabled action types for sync
    allowAction = _c === void 0 ? function () { return true; } : _c, // Callback to decide if an action should sync with live state
    _d = config.liveStateDataId, // Callback to decide if an action should sync with live state
    liveStateDataId = _d === void 0 ? VELT_DEFAULT_LIVE_STATE_ID : _d;
    if (!liveStateDataId) {
        liveStateDataId = VELT_DEFAULT_LIVE_STATE_ID;
    }
    var internalStore; // This variable will hold the reference to the store
    var dataSubscription; // This variable will hold the reference to the data subscription
    var isSdkInitialized = false;
    var setupGetDataSubscription = function () {
        var _a, _b;
        try {
            if (!dataSubscription && window.Velt && ((_a = window.Velt) === null || _a === void 0 ? void 0 : _a.getLiveStateSyncElement)) {
                var liveStateSyncElement = (_b = window.Velt) === null || _b === void 0 ? void 0 : _b.getLiveStateSyncElement();
                dataSubscription = liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData(liveStateDataId).subscribe(function (data) {
                    // Dispatch action to update local state, marking it as remote
                    if (data) {
                        var sessionId_1 = getSessionId();
                        if (data.id === sessionId_1) {
                            return;
                        }
                        else {
                            internalStore === null || internalStore === void 0 ? void 0 : internalStore.dispatch(__assign(__assign({}, data.action), { isRemote: true }));
                        }
                    }
                });
            }
        }
        catch (err) {
        }
    };
    var updateLiveStateDataId = function (newId) {
        try {
            liveStateDataId = newId || VELT_DEFAULT_LIVE_STATE_ID;
            if (dataSubscription) {
                dataSubscription.unsubscribe();
                dataSubscription = null;
            }
            if (isSdkInitialized) {
                setupGetDataSubscription();
            }
        }
        catch (err) {
            // handle error
        }
    };
    var updateAllowedActionTypes = function (newAllowedActionTypes) {
        try {
            allowedActionTypes = newAllowedActionTypes || new Set();
        }
        catch (err) {
            // handle error
        }
    };
    var updateDisabledActionTypes = function (newDisabledActionTypes) {
        try {
            disabledActionTypes = newDisabledActionTypes || new Set();
        }
        catch (err) {
            // handle error
        }
    };
    var updateAllowAction = function (newAllowAction) {
        try {
            allowAction = newAllowAction || (function () { return true; });
        }
        catch (err) {
            // handle error
        }
    };
    var middleware = function (store) {
        internalStore = store;
        var veltSdkInitializedListener = function () {
            try {
                if (window.Velt) {
                    isSdkInitialized = true;
                    setupGetDataSubscription();
                    // Remove the event listener after it's triggered
                    window.removeEventListener(VELT_SDK_INIT_EVENT, veltSdkInitializedListener);
                }
            }
            catch (err) {
                // handle error
            }
        };
        // Add the event listener for the veltSdkInitialized event
        window.addEventListener(VELT_SDK_INIT_EVENT, veltSdkInitializedListener);
        return function (next) { return function (action) {
            // Always process the action locally
            var result = next(action);
            // Decide whether to sync this action with Firebase
            if (isSdkInitialized && !action.isRemote && allowAction(action) && !disabledActionTypes.has(action.type) && (allowedActionTypes.size === 0 || allowedActionTypes.has(action.type))) {
                logLiveState(action, liveStateDataId);
            }
            return result;
        }; };
    };
    return {
        middleware: middleware,
        updateLiveStateDataId: updateLiveStateDataId,
        updateAllowedActionTypes: updateAllowedActionTypes,
        updateDisabledActionTypes: updateDisabledActionTypes,
        updateAllowAction: updateAllowAction,
    };
};
var logLiveState = function (action, liveStateDataId) {
    var _a, _b;
    try {
        if (window.Velt && ((_a = window === null || window === void 0 ? void 0 : window.Velt) === null || _a === void 0 ? void 0 : _a.getLiveStateSyncElement)) {
            var sessionId_2 = getSessionId();
            var liveStateElement = (_b = window === null || window === void 0 ? void 0 : window.Velt) === null || _b === void 0 ? void 0 : _b.getLiveStateSyncElement();
            if (liveStateElement === null || liveStateElement === void 0 ? void 0 : liveStateElement.setLiveStateData) {
                liveStateElement.setLiveStateData(liveStateDataId, {
                    id: sessionId_2,
                    action: action,
                    timestamp: Date.now(),
                });
            }
        }
    }
    catch (err) {
        // handle error
    }
};
